"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherMoreTransactionList = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _ = require("../..");
var _InfiniteScroll = require("../InfiniteScroll");
var _getPrefixCls = require("../../utils/getPrefixCls");
var _cb_ic_withdraw = _interopRequireDefault(require("../../assets/images/cb_ic_withdraw.png"));
var _cb_ic_topup = _interopRequireDefault(require("../../assets/images/cb_ic_topup.png"));
var _2 = require(".");
var _useTracking = require("../../hooks/useTracking");
var _context2 = require("../ConfigProvider/context");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var OtherMoreTransactionList = function OtherMoreTransactionList(props) {
  var loadMoreFn = props.loadMoreFn,
    type = props.type,
    _props$limit = props.limit,
    limit = _props$limit === void 0 ? 10 : _props$limit,
    onTransactionCardClick = props.onTransactionCardClick,
    stillNotFoundContent = props.stillNotFoundContent,
    checkHereAction = props.checkHereAction,
    componentTrackingData = props.componentTrackingData,
    onClose = props.onClose;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    listData = _useState2[0],
    setListData = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    startIndex = _useState6[0],
    setStartIndex = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    loadMore = _useState8[0],
    setLoadMore = _useState8[1];
  function reset() {
    setStartIndex(0);
    setLoadMore(true);
    setLoading(false);
    setListData([]);
  }
  (0, _react.useEffect)(function () {
    loadMoreCb();
    return function () {
      reset();
    };
  }, []);
  var loadMoreCb = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var res, data, image;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(!loadMore || loading)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              // 设置状态为正在加载
              setLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return loadMoreFn({
                page_num: startIndex,
                page_size: limit,
                status: type
              });
            case 6:
              res = _context.sent;
              data = res.data;
              image = type === _2.TransactionType.Topup ? _cb_ic_topup.default : _cb_ic_withdraw.default;
              if (data) {
                // 如果列表为空，则认为加载完成，同时设置加载状态为加载完
                if (data.length === 0) {
                  setLoadMore(false);
                  setLoading(false);
                } else {
                  // 分页并设置单次加载完成
                  setStartIndex(startIndex + 1);
                  setListData(listData.concat(data.map(function (item) {
                    return _objectSpread(_objectSpread({}, item), {
                      image: image
                    });
                  })));
                  setLoading(false);
                  setLoadMore(true);
                }
              } else {
                setLoading(false);
                setLoadMore(false);
              }
              _context.next = 16;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              setLoading(false);
              console.error(_context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    }));
    return function loadMoreCb() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('scroll-list-container')
  }, /*#__PURE__*/_react.default.createElement(_InfiniteScroll.InfiniteScroll, {
    onLoadMore: loadMoreCb,
    className: (0, _getPrefixCls.getPrefixCls)('transaction-list-infinite-scroll')
  }, /*#__PURE__*/_react.default.createElement("div", null, listData.map(function (transaction, index) {
    return /*#__PURE__*/_react.default.createElement(TransactionItem, {
      key: transaction.title,
      transaction: transaction,
      index: index,
      componentTrackingData: componentTrackingData,
      onTransactionCardClick: onTransactionCardClick
    });
  }))), /*#__PURE__*/_react.default.createElement(RenderFooter, {
    componentTrackingData: componentTrackingData,
    stillNotFoundContent: stillNotFoundContent,
    checkHereAction: checkHereAction,
    onClose: onClose
  })));
};
exports.OtherMoreTransactionList = OtherMoreTransactionList;
var TransactionItem = function TransactionItem(props) {
  var transaction = props.transaction,
    index = props.index,
    componentTrackingData = props.componentTrackingData,
    onTransactionCardClick = props.onTransactionCardClick;
  var _useComponentTracking = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData,
      componentData: {
        transaction: transaction,
        index: index
      }
    }),
    tracker = _useComponentTracking.tracker,
    panelTransactionTracking = _useComponentTracking.result.panelTransaction;
  var handleCardClick = function handleCardClick(transaction) {
    (panelTransactionTracking === null || panelTransactionTracking === void 0 ? void 0 : panelTransactionTracking.trackingClick) && tracker.click(panelTransactionTracking.trackingClick);
    onTransactionCardClick === null || onTransactionCardClick === void 0 ? void 0 : onTransactionCardClick({
      data: transaction
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    key: index,
    onClick: function onClick() {
      return handleCardClick(transaction);
    }
  }, panelTransactionTracking === null || panelTransactionTracking === void 0 ? void 0 : panelTransactionTracking.trackingImpressionProps), index !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _getPrefixCls.getPrefixCls)('transaction-list-gap')
  }), /*#__PURE__*/_react.default.createElement(_.Transaction, (0, _extends2.default)({
    layout: "vertical"
  }, transaction)));
};
var RenderFooter = function RenderFooter(props) {
  var componentTrackingData = props.componentTrackingData,
    stillNotFoundContent = props.stillNotFoundContent,
    checkHereAction = props.checkHereAction;
  var context = (0, _react.useContext)(_context2.ConfigContext);
  var _useComponentTracking2 = (0, _useTracking.useComponentTracking)({
      componentTrackingData: componentTrackingData
    }),
    tracker = _useComponentTracking2.tracker,
    panelDoNotSeeTransactionTracking = _useComponentTracking2.result.panelDoNotSeeTransaction;
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: (0, _getPrefixCls.getPrefixCls)('transaction-list-footer'),
    onClick: function onClick() {
      var _context$eventEmitter, _props$checkHereActio;
      props.onClose();
      context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : _context$eventEmitter.emit('next', {
        text: stillNotFoundContent,
        action: _objectSpread(_objectSpread({}, checkHereAction), {}, {
          _actualText_: stillNotFoundContent,
          nextParams: _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$checkHereActio = props.checkHereAction) === null || _props$checkHereActio === void 0 ? void 0 : _props$checkHereActio.nextParams), {}, {
            message_text: stillNotFoundContent
          })
        })
      });
      (panelDoNotSeeTransactionTracking === null || panelDoNotSeeTransactionTracking === void 0 ? void 0 : panelDoNotSeeTransactionTracking.trackingClick) && tracker.click(panelDoNotSeeTransactionTracking === null || panelDoNotSeeTransactionTracking === void 0 ? void 0 : panelDoNotSeeTransactionTracking.trackingClick);
    }
  }, panelDoNotSeeTransactionTracking === null || panelDoNotSeeTransactionTracking === void 0 ? void 0 : panelDoNotSeeTransactionTracking.trackingImpressionProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, stillNotFoundContent));
};